import { render, staticRenderFns } from "./WholesalePackage.vue?vue&type=template&id=ce1dcd14&scoped=true"
import script from "./WholesalePackage.vue?vue&type=script&lang=js"
export * from "./WholesalePackage.vue?vue&type=script&lang=js"
import style0 from "./WholesalePackage.vue?vue&type=style&index=0&id=ce1dcd14&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "ce1dcd14",
  null
  
)

export default component.exports